import { roundNumber } from './helper';
import { TitleValueType } from './summaryReportHelper';

export const formatProcedureData = (data: any) => {
  const procedureData: TitleValueType[] = [];

  data?.map((item: any) => {
    const eachValue: TitleValueType = {
      title: '',
      value: 0,
    };
    if (item.procedure !== '') {
      eachValue.title = item.procedure;
      eachValue.value = roundNumber(item.procedurePercent, 2);
      procedureData.push(eachValue);
    }
  });

  return procedureData?.slice(0, 5);
};
